var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear / Settings, Fine Tuning / Widget 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1880",
    d: "M1.875 4.875C1.875 3.21815 3.21815 1.875 4.875 1.875C6.53185 1.875 7.875 3.21815 7.875 4.875V6.875C7.875 7.10749 7.875 7.22374 7.84944 7.31911C7.78009 7.57793 7.57793 7.78009 7.31911 7.84944C7.22374 7.875 7.10749 7.875 6.875 7.875H4.875C3.21815 7.875 1.875 6.53185 1.875 4.875Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1884",
    d: "M10.125 11.125C10.125 10.8925 10.125 10.7763 10.1506 10.6809C10.2199 10.4221 10.4221 10.2199 10.6809 10.1506C10.7763 10.125 10.8925 10.125 11.125 10.125H13.125C14.7819 10.125 16.125 11.4681 16.125 13.125C16.125 14.7819 14.7819 16.125 13.125 16.125C11.4681 16.125 10.125 14.7819 10.125 13.125V11.125Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1883",
    d: "M1.875 13.125C1.875 11.4681 3.21815 10.125 4.875 10.125H6.675C7.09504 10.125 7.30506 10.125 7.46549 10.2067C7.60661 10.2787 7.72135 10.3934 7.79325 10.5345C7.875 10.6949 7.875 10.905 7.875 11.325V13.125C7.875 14.7819 6.53185 16.125 4.875 16.125C3.21815 16.125 1.875 14.7819 1.875 13.125Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1881",
    d: "M10.125 4.875C10.125 3.21815 11.4681 1.875 13.125 1.875C14.7819 1.875 16.125 3.21815 16.125 4.875C16.125 6.53185 14.7819 7.875 13.125 7.875H10.9821C10.8826 7.875 10.8329 7.875 10.791 7.87028C10.4433 7.83111 10.1689 7.55669 10.1297 7.20897C10.125 7.16712 10.125 7.11737 10.125 7.01786V4.875Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidget);
export default __webpack_public_path__ + "static/media/widget.32d1961f55643324dea3a44b9f7639ca.svg";
export { ForwardRef as ReactComponent };